document.addEventListener('DOMContentLoaded', () => {
   const filters = document.querySelectorAll('[data-select-filter]');

   filters.forEach(select => {
      select.addEventListener('change', function () {
         const url = this.value;
         if (url) {
            window.location.href = url + '?scrollTo=list';
         }
      });
   });
});
